import React from 'react'

import {SelectParent_SectionType} from "../../@const"
import SelectParent_Spaces from "./spaces"
import ProjectSelect_CompanyNoProjects from "./company-no-projects"
import {SpaceProto} from "../../../../model2/space/space-proto"
import SelectParent_CollapsableProjectsTree from "./right/projects-tree"
import {selectParent_recursiveUpdateExpandState} from "../../actions/filter"
import {selectParent_getProjects} from "../../actions/get-projects"
import Workspace from "../../../../model2/space/workspaces/workspace"
import {selectParent_getInitialCurrentSection} from "../../actions/get-initial-current-section"
import ProjectSession from "../../../../model2/project/project-session"
import SelectParent_AllProjects from "./right/all-projects"
import {ITreeSelectorParent} from "../tree-new/project-tree-new"
import {ProjectsTreeSortType} from "../../../../model2/space/@types"
import UILoading from "../../../loading/loading"
import ProjectSessionCollection from "../../../../model2/project/collection"
import {ItemDisplay} from "../../../../model2/item/@type";

type Props = {
    className?          : string
    parentSelector      : ITreeSelectorParent
    onParentSelected    : callback
}

type State = {
    searchString            : string
    currentSection?         : SelectParent_SectionType | SpaceProto // ProjectSession - when workspace
    availableProjectsLoaded : boolean
}

// const debug = "SelectParent_Popover"
const debug = false

export default class SelectParent_Popover extends React.Component<Props, State> {

    public spaces               : SpaceProto[]

    public spacesToShow         : SpaceProto[]
    public showStarred          : boolean
    public showPinned           : boolean

    public availableProjects?   : ProjectSessionCollection

    constructor(props: Props) {
        super(props)

        this.spaces = _.filter(gd.spaces.spacesWithProjects, (space: SpaceProto) => space.enabled)

        const {hideStarred, hidePinned, availableProjects, getAvailableProjects, unselectLabel} = props.parentSelector.props

        this.spacesToShow   = this.spaces
        this.showStarred    = !hideStarred
        this.showPinned     = !hidePinned

        const availableProjectsLoaded = !!availableProjects || !getAvailableProjects
        if (availableProjectsLoaded) {
            this._updateShownSections()
        }

        this.state = {
            currentSection          : selectParent_getInitialCurrentSection(this.props.parentSelector.selectedProjects, this.spacesToShow, !!unselectLabel),
            searchString            : "",
            availableProjectsLoaded : availableProjectsLoaded
        }

        this.availableProjects = availableProjects

        this._updateInitialExpand()
    }

    componentDidMount() {
        if (!this.state.availableProjectsLoaded) {
            this.loadOptions()
        }
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    async loadOptions() {
        const availableProjects = await this.props.parentSelector.props.getAvailableProjects?.()
        debug && console.log(debug, 'loadOptions', availableProjects)

        if (!availableProjects?.isEmpty) {
            this.availableProjects = availableProjects
            this._updateShownSections(true)
        }

        this.setState({
            availableProjectsLoaded : true
        })
    }

    _updateShownSections(hideEmptySections: boolean = false) {
        debug && console.log(debug, '_updateShownSections', this.props.parentSelector.props.hideEmptySections, hideEmptySections, this.availableProjects)

        if (this.props.parentSelector.props.hideEmptySections || hideEmptySections) {
            this.spacesToShow = _.filter(this.spaces, (space:SpaceProto)=>{
                const projects = _.filter(selectParent_getProjects(space, {
                    availableProjects   : this.availableProjects,
                    parentsFor          : this.props.parentSelector.parentsFor
                }), (projectSession: ProjectSession) => {
                    return [ItemDisplay.VISIBLE, ItemDisplay.GHOST_VISIBLE].includes(projectSession.treeDisplay)
                })

                debug && console.log(debug, 'filter spaces', projects.length > 0, projects, space)

                return projects.length > 0
            })

            const starredProjects = _.filter(selectParent_getProjects(SelectParent_SectionType.STARRED, {
                availableProjects   : this.availableProjects,
                parentsFor          : this.props.parentSelector.parentsFor
            }), (projectSession: ProjectSession) => {
                return projectSession.treeDisplay === ItemDisplay.VISIBLE
            })

            debug && console.log(debug, 'filter starred', starredProjects)

            this.showStarred = starredProjects.length > 0

            const pinnedProjects = _.filter(selectParent_getProjects(SelectParent_SectionType.PINNED, {
                availableProjects   : this.availableProjects,
                parentsFor          : this.props.parentSelector.parentsFor
            }), (projectSession: ProjectSession) => {
                return projectSession.treeDisplay === ItemDisplay.VISIBLE
            })

            debug && console.log(debug, 'filter pinned', pinnedProjects)

            this.showPinned = pinnedProjects.length > 0
        }
    }

    _updateInitialExpand() {

        // expand workspaces
        _.map(this.spaces, (space: SpaceProto) => {
            const project = (space as Workspace).project
            if (project) {
                project.treeIsExpandedProjectSelector = true
            }
        })

        // update initial expand state for each project
        selectParent_recursiveUpdateExpandState(
            this.state.currentSection,
            this.props.parentSelector.selectedProjects,
            this.availableProjects
        )
    }

    onSelectSection = (section: SelectParent_SectionType)=> {
        this.setState({
            currentSection: section
        })
    }

    onSelectWorkspace = (space?: SpaceProto)=> {
        this.setState({
            currentSection: space
        })
    }

    hidePopover = ()=>{
        this.props.parentSelector.hidePopover?.()
        this.setState({searchString: ""})
    }

    // search changed....
    onSearchChange = (searchString: string) => {
        // restore expanded projects if search string is empty
        if (!searchString) {
            this._updateInitialExpand()
        }

        this.setState({
            searchString: searchString
        })
    }

    render() {
        if (!this.state.availableProjectsLoaded) {
            return (
                <div className="flex-row-center-center h-400" style={{width: 575}}>
                    <UILoading className="inline" size="normal" message=""/>
                </div>
            )
        }

        const companyHasNoProjects = false // gd.session.projects.companyHasNoProjects

        let rightContent

        const currentSection = _.isEmpty(this.state.searchString) ? this.state.currentSection : SelectParent_SectionType.SEARCH
        const projects = selectParent_getProjects(currentSection, {
            availableProjects   : this.availableProjects,
            searchString        : this.state.searchString,
            parentsFor          : this.props.parentSelector.parentsFor
        })

        if (currentSection) {
            switch (currentSection) {
                case SelectParent_SectionType.STARRED:
                    rightContent = (
                        <SelectParent_CollapsableProjectsTree parentSelector    = {this.props.parentSelector}
                                                              projects          = {_.filter(projects, (project: ProjectSession) => !project.treeIsHidden)}
                                                              colorized         = {true}
                                                              sortType          = {ProjectsTreeSortType.ALPHABETICAL}
                                                              section           = {currentSection}
                                                              onParentSelected  = {this.props.onParentSelected}
                                                              notFoundMessage   = "No starred items found."/>
                    )

                    break

                case SelectParent_SectionType.PINNED:

                    rightContent = (
                        <SelectParent_CollapsableProjectsTree parentSelector    = {this.props.parentSelector}
                                                              projects          = {_.filter(projects, (project: ProjectSession) => !project.treeIsHidden)}
                                                              sortType          = {ProjectsTreeSortType.ALPHABETICAL}
                                                              colorized         = {true}
                                                              section           = {currentSection}
                                                              onParentSelected  = {this.props.onParentSelected}
                                                              notFoundMessage   = "No pinned items found."/>
                    )

                    break


                case SelectParent_SectionType.SEARCH:
                    rightContent = (
                        <SelectParent_CollapsableProjectsTree parentSelector    = {this.props.parentSelector}
                                                              projects          = {projects}
                                                              colorized         = {true}
                                                              sortType          = {ProjectsTreeSortType.ALPHABETICAL}
                                                              section           = {currentSection}
                                                              onParentSelected  = {this.props.onParentSelected}
                                                              notFoundMessage   = "No projects found."
                                                              applyTreeDisplay  = {true}/>
                    )

                    break

                default:
                    const space = currentSection as SpaceProto

                    rightContent = (
                        <SelectParent_CollapsableProjectsTree parentSelector    = {this.props.parentSelector}
                                                              projects          = {projects}
                                                              colorized         = {true}
                                                              sortType          = {space.projectsSorting}
                                                              section           = {currentSection}
                                                              onParentSelected  = {this.props.onParentSelected}
                                                              notFoundMessage   = "No projects found."/>
                    )
            }
        } else {
            rightContent = <SelectParent_AllProjects/>
        }

        return (
            <>
                {companyHasNoProjects &&
                    <ProjectSelect_CompanyNoProjects parent={this.props.parentSelector}/>
                    }

                {!companyHasNoProjects &&
                    <div className="flex-row-left-top h-400">
                        <SelectParent_Spaces parent={this}/>

                        <div className="flex-column-right-top w-350 h-100-percent">
                            {rightContent}
                        </div>
                    </div>}
            </>
        )
    }
}
